import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationComputeDismissedDataSelector } from "./recommendationComputeDismissedDataSelector";

export const recommendationComputeDismissedDataLengthSelector =
  createDraftSafeSelector(
    [recommendationComputeDismissedDataSelector],
    (data) => data?.length ?? 0,
  );
